module.exports = __webpack_public_path__ + "assets/media/evening.4e8c97c5.mp3";